import { cx } from '@emotion/css';
import type { CSSProperties, FC } from 'react';

import type { BaseComponentProps } from '../../types';
import {
  editorialGalleryCardBodyCss,
  editorialGalleryCardBrandDateSkeletonCss,
  editorialGalleryCardBrandSkeletonCss,
  editorialGalleryCardButtonSkeletonCss,
  editorialGalleryCardClassName,
  editorialGalleryCardContainerCss,
  editorialGalleryCardContentCss,
  editorialGalleryCardLayoutCss,
  editorialGalleryCardMediaContainerCss,
  editorialGalleryCardMetadataSkeletonCss,
  editorialGalleryCardPreviewCss,
  editorialGalleryCardSkeletonAnimationCss,
  editorialGalleryCardSkeletonBarCss,
  editorialGalleryCardSkeletonCss,
  editorialGalleryCardSkeletonDescriptionCss,
  editorialGalleryCardSkeletonMediaCss,
  editorialGalleryCardSkeletonTitleLinesCss,
  editorialGalleryCardTextGroupSkeletonCss,
} from './EditorialGalleryCard.styles';

const titleLines = [
  { height: 20, width: 85 },
  { height: 20, width: 60 },
];

const descriptionLines = [
  { height: 12, width: 90 },
  { height: 12, width: 70 },
];

export const SkeletonEditorialGalleryCard: FC<BaseComponentProps> = ({ className }) => {
  const dashClassName = cx(
    editorialGalleryCardSkeletonCss,
    editorialGalleryCardSkeletonAnimationCss
  );

  return (
    <div
      className={cx(editorialGalleryCardContainerCss, className)}
      data-testid="skeleton-editorial-gallery-card-container"
      aria-hidden="true"
    >
      <div className={cx(editorialGalleryCardClassName, editorialGalleryCardLayoutCss)}>
        <div className={editorialGalleryCardContentCss}>
          <div className={editorialGalleryCardMetadataSkeletonCss}>
            <div className={cx(dashClassName, editorialGalleryCardBrandSkeletonCss)} />
            <div className={cx(dashClassName, editorialGalleryCardBrandDateSkeletonCss)} />
          </div>
          <div className={editorialGalleryCardPreviewCss}>
            <div className={editorialGalleryCardMediaContainerCss}>
              <div className={cx(dashClassName, editorialGalleryCardSkeletonMediaCss)} />
            </div>
            <div className={editorialGalleryCardBodyCss}>
              <div className={editorialGalleryCardTextGroupSkeletonCss}>
                <div className={editorialGalleryCardSkeletonTitleLinesCss}>
                  {titleLines.map(({ height, width }, index) => (
                    <div
                      key={`skeleton-title-${index}`}
                      className={cx(dashClassName, editorialGalleryCardSkeletonBarCss)}
                      style={
                        {
                          '--skeleton-bar-height': `${height}px`,
                          '--skeleton-bar-width': `${width}%`,
                        } as CSSProperties
                      }
                    />
                  ))}
                </div>
                <div className={editorialGalleryCardSkeletonDescriptionCss}>
                  {descriptionLines.map(({ height, width }, index) => (
                    <div
                      key={`skeleton-desc-${index}`}
                      className={cx(dashClassName, editorialGalleryCardSkeletonBarCss)}
                      style={
                        {
                          '--skeleton-bar-height': `${height}px`,
                          '--skeleton-bar-width': `${width}%`,
                        } as CSSProperties
                      }
                    />
                  ))}
                </div>
              </div>
              <div className={cx(dashClassName, editorialGalleryCardButtonSkeletonCss)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SkeletonEditorialGalleryCard.displayName = 'SkeletonEditorialGalleryCard';
